import { useCurrentUser } from "./useCurrentUser";

export function useCurrentUserProjects() {
  return useCurrentUser().projects;
}
